import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ChartType, ChartOptions, ChartDataSets, RadialChartOptions } from 'chart.js';
import { SingleDataSet, Label, monkeyPatchChartJsLegend, monkeyPatchChartJsTooltip } from 'ng2-charts';
import { ReportserviceService } from '../../reportservice.service';
import { DatePipe } from '@angular/common';
import { MatTableDataSource } from '@angular/material/table';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { PatientDetailModel } from 'app/opdvisits/Models/patient_details.model';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';
import { ExportService } from 'app/reports/services/export.service';
import { AuthService } from 'app/auth/auth.service';


@Component({
  selector: 'app-registrationcommonreports',
  templateUrl: './registrationcommonreports.component.html',
  styleUrls: ['./registrationcommonreports.component.scss']
})
export class RegistrationcommonreportsComponent implements OnInit {


  patientcount;
  dataSource = new MatTableDataSource<PatientDetailModel>();
  startdate;
  enddate;
  pname = "";
  pageHeading: any;
  public toDaysDate: any;

  public RegistrationArray: any = [];
  isShowDivIf = false;
  isGraph = false;
  ismonthly = false;
  isgrapandData = false;
  isdatewise = false;
  isnewcolor = false;
  isBarChart = false;

  grandTotal: any;
  freshTotal: any;
  reviewTotal: any;
  maleTotal: any;
  femaleTotal: any;
  crossReffTotal: any;
  dialtedTotal: any;
  walkingTotal: any;
  appointmentTotal: any;
  TatTotal: any;
  ReportType: any;
  checkgroupType: any;

  GroupByCountry: any = [];
  GroupByState: any = [];
  GroupByDistric: any = [];
  GroupByCity: any = [];
  GroupByOccupation: any = [];

  public commonParamete: any;
  public checkReportType: number;
  public setcharttype;
  public senddataArray: any = [];
  public serchdata: any = [];
  public Labels = ['Patient ID', 'Reg. Date', 'PatientName', 'DOB',
    'Gender', 'Address', 'Mobile No', 'Aadhaar Card No.', 'Email'];
  public cityLabels = ['Patient ID', 'Reg. Date', 'Patient Name', 'Age',
    'Gender', 'Address','City', 'Mobile No'];
  public GraphLabels: any = []
  public NewLabelData: any = [];
  public FillterArray: any = ['COUNTRY', 'STATE', 'DISTRICT', 'CITY', 'OCCUPATION', 'GROUP',
    'NATIONALITY', 'RELIGION'];

  public pieChartOptions: ChartOptions = {
    responsive: true,
    tooltips: { enabled: false },
    hover: { mode: null },
    events: []
  };
  public pieChartData: ChartDataSets[] = [
    { data: [ ], label: ' ' }
  ];
  public pieChartLabels: Label[] = this.Labels;
  public pieChartType: ChartType = 'pie';
  public pieChartLegend = true;
  public pieChartPlugins = [];
  public pieChartDataArray: any = [];
  lineChartLegend = true;
  barChartLegend = true;

  // Define type of chart
  lineChartType = 'line';

  lineChartPlugins = [];
  UserDataArray: any;
  citylist: any;
  patientTotal: number;
  RegistrationArraycity: any=[];
  alltotalCount: any;
  citywise: boolean;



  constructor(public reportservice: ReportserviceService, public dbservice: DashboardService,
    public opdvisitService: OpdVisitService, public authService :AuthService,
    private datePipe: DatePipe, private exportdata: ExportService) {
    monkeyPatchChartJsTooltip();
    monkeyPatchChartJsLegend();

  }

  ngOnInit(): void {
    this.startdate = this.authService.getServerDate;
    this.enddate = this.authService.getServerDate;
    this.toDaysDate =this.authService.getServerDate;
    this.toDaysDate = this.datePipe.transform(this.toDaysDate, "yyyy-MM-dd");
    console.log(this.toDaysDate);
    this.commonParamete = this.toDaysDate;
    this.ReportType = 'COUNTRY';
    this.checkgroupType = "India"
    this.reportservice.getRegistrationCommonReports(this.toDaysDate, this.toDaysDate, this.ReportType).
      subscribe(data => this.success_pat_sdate_edate(data), err => this.failed_pat_sdate_edate(err));
      this.GroupByCountry = [];
    // this.checkReportType = 1;
    // this.ReportType='Date';
    this.regreportsType();
    this.setPageHeading();
    //  console.log('filterArray',this.FillterArray);


  }

  setPageHeading() {
    let sdate = this.datePipe.transform(this.startdate, "yyyy-MM-dd");
    let edate = this.datePipe.transform(this.enddate, "yyyy-MM-dd");
    this.pageHeading = `Patient Registration ${this.ReportType} Wise  Reports From ${sdate} To ${edate}`;
  }

  regreportsType() {
    switch (this.dbservice.reportTitle) {
      case 'Patient Registration City Wise':
        {
          this.ReportType = 'CITY';
          break;
        }
      case 'Patient Registration Country Wise':
        {
          this.ReportType = 'COUNTRY';
          break;
        }
      case 'Patient Registration Date Wise':
        {
          this.ReportType = 'Date';
          break;
        }
      case 'Patient Registration Group Wise':
        {
          this.ReportType = 'GROUP';
          break;
        }
      case 'Patient Registration Occupation Wise':
        {
          this.ReportType = 'OCCUPATION';
          break;
        }
      case 'Patient Registration Religion Wise':
        {
          this.ReportType = 'RELIGION';
          break;
        }
      case 'Patient Registration Source Wise':
        {
          this.ReportType = 'Quarterly';
          break;
        }
      case 'Patient Registration State Wise':
        {
          this.ReportType = 'STATE';
          break;
        }
      default: {
        this.get_records_between_two_dates();
        break;
      }
    }
    this.get_records_between_two_dates();
  }

  toggleDisplayDivIf() {
    this.isShowDivIf = !this.isShowDivIf;
  }

  togglegraphIf() {
    this.isGraph = !this.isGraph;
  }

  togglegraphDataIf() {
    this.isgrapandData = !this.isgrapandData;
  }


  GetTotal(data: any) {
    this.grandTotal = 0;
    this.freshTotal = 0;
    this.reviewTotal = 0;
    this.maleTotal = 0;
    this.femaleTotal = 0;
    this.crossReffTotal = 0;
    this.dialtedTotal = 0;
    this.walkingTotal = 0;
    this.appointmentTotal = 0;
    this.TatTotal = 0;

    //   data.forEach((element:any) => {
    //    this.grandTotal = this.grandTotal+element.total;
    //    this.freshTotal = this.freshTotal+element.fresh;
    //    this.reviewTotal = this.reviewTotal+element.review;
    //    this.maleTotal = this.maleTotal+element.male;
    //    this.femaleTotal = this.femaleTotal+element.female;
    //    this.crossReffTotal = this.crossReffTotal+element.crossReff;
    //    this.dialtedTotal = this.dialtedTotal+element.dilated;
    //    this.walkingTotal = this.walkingTotal+element.walkIn;
    //    this.appointmentTotal = this.appointmentTotal+element.withAppt;
    //    this.TatTotal = this.TatTotal+element.tat;
    //  }) ;

  }


  getReportsType(name: any) {
    var val = name.value;
    console.log(val)
    this.ReportType = val;
    this.get_records_between_two_dates();
    this.setPageHeading();
    this.GroupByCountry = [];

  }

  getGroupType(name: any) {
    var val = name.value;
    this.checkgroupType = val;
    console.log(this.checkgroupType);
    this.get_records_between_two_dates();
    this.setPageHeading();
  }

  groupBy(list, keyGetter) {
    const map = new Map();
    list.forEach((item) => {
      const key = keyGetter(item);
      const collection = map.get(key);
      if (!collection) {
        map.set(key, [item]);
      } else {
        collection.push(item);
      }
    });
    return map;
  }

  // example usage


  // const grouped = groupBy(pets, pet => pet.type);

  // console.log(grouped.get("Dog")); // -> [{type:"Dog", name:"Spot"}, {type:"Dog", name:"Rover"}]
  // console.log(grouped.get("Cat")); // -> [{type:"Cat", name:"Tiger"}, {type:"Cat", name:"Leo"}]


  get_records_between_two_dates() {
    let sdate = this.datePipe.transform(this.startdate, "yyyy-MM-dd");
    let edate = this.datePipe.transform(this.enddate, "yyyy-MM-dd");
    this.reportservice.getRegistrationCommonReports(sdate, edate, this.ReportType).
      subscribe(data => this.success_pat_sdate_edate(data), err => this.failed_pat_sdate_edate(err));
  }

  success_pat_sdate_edate(data) {
    this.citywise = false;
    if (data.length > 0) {


      console.log('report type', this.ReportType);
      if (this.ReportType == 'COUNTRY') {
        const grouped = this.groupBy(data, pet => pet.countryName);
        this.RegistrationArray = grouped.get(this.checkgroupType);
        console.log('grouped Array', this.RegistrationArray);
        data.forEach(elem => {
          this.GroupByCountry.push(elem.countryName);
        });
        this.GroupByCountry = [...new Set(this.GroupByCountry)];

      }
      else if (this.ReportType == 'STATE') {
        const grouped = this.groupBy(data, pet => pet.stateName);
        this.RegistrationArray = grouped.get(this.checkgroupType);

        console.log('grouped Array', this.RegistrationArray);
        data.forEach(elem => {
          this.GroupByCountry.push(elem.stateName);
        });
        this.GroupByCountry = [...new Set(this.GroupByCountry)];


      }

      else if (this.ReportType == 'DISTRICT') {
        const grouped = this.groupBy(data, pet => pet.districtname);
        this.RegistrationArray = grouped.get(this.checkgroupType);
        console.log('grouped Array', this.RegistrationArray);
        data.forEach(elem => {
          this.GroupByCountry.push(elem.districtname);
        });
        this.GroupByCountry = [...new Set(this.GroupByCountry)];

      }
      else if (this.ReportType == 'CITY') {
        this.citywise = true;
        this.RegistrationArraycity =[];
        this.alltotalCount = 0;        
        this.citylist= data;
        this.UserDataArray = data.reduce((s, { cityName }) => {
          if (!s.some(o => o.cityName == cityName)) {
            s.push({ cityName });
          }
          return s;
        }, []);
        const grouped = this.groupBy(data, pet => pet.cityName);
        this.RegistrationArray = grouped.get(this.checkgroupType);
        console.log('grouped Array', this.RegistrationArray);
        data.forEach(elem => {
          this.GroupByCountry.push(elem.cityName);
        });
        this.GroupByCountry = [...new Set(this.GroupByCountry)];
        this.cityFilter();
      }
      else if (this.ReportType == 'OCCUPATION') {
        const grouped = this.groupBy(data, pet => pet.occupation);
        this.RegistrationArray = grouped.get(this.checkgroupType);
        console.log('grouped Array', this.RegistrationArray);
        data.forEach(elem => {
          this.GroupByCountry.push(elem.occupation);
        });
        this.GroupByCountry = [...new Set(this.GroupByCountry)];

      }

      else if (this.ReportType == 'GROUP') {
        const grouped = this.groupBy(data, pet => pet.groupName);
        this.RegistrationArray = grouped.get(this.checkgroupType);
        console.log('grouped Array', this.RegistrationArray);
        data.forEach(elem => {
          this.GroupByCountry.push(elem.groupName);
        });
        this.GroupByCountry = [...new Set(this.GroupByCountry)];

      }
      else if (this.ReportType == 'NATIONALITY') {
        const grouped = this.groupBy(data, pet => pet.nationality);
        this.RegistrationArray = grouped.get(this.checkgroupType);
        console.log('grouped Array', this.RegistrationArray);
        data.forEach(elem => {
          this.GroupByCountry.push(elem.nationality);
        });
        this.GroupByCountry = [...new Set(this.GroupByCountry)];

      }
      else if (this.ReportType == 'RELIGION') {
        const grouped = this.groupBy(data, pet => pet.religion);
        this.RegistrationArray = grouped.get(this.checkgroupType);
        console.log('grouped Array', this.RegistrationArray);
        data.forEach(elem => {
          this.GroupByCountry.push(elem.religion);
        });
        this.GroupByCountry = [...new Set(this.GroupByCountry)];

      }



      // -> [{type:"Dog", name:"Spot"}, {type:"Dog", name:"Rover"}]
      //  console.log(grouped.get("Cat"));

      console.log('common data reg', data);
      this.setBargraphData();
      this.setPageHeading();

      // this.GetTotal(this.RegistrationArray)
    }
    else {
      this.RegistrationArray = [];
    }
  }
  failed_pat_sdate_edate(err) {
    // this.showspinner = false;
  }

  setPiegraphData() {
    let countArray = [];
    let DateArray = [];
    this.pieChartDataArray = [];
    this.NewLabelData = [];

    if (this.RegistrationArray?.length > 0) {
      this.RegistrationArray?.forEach(element => {
        DateArray.push(element.regDate)
       this.NewLabelData.push(this.datePipe.transform(element.regDate, "yyyy-MM-dd"))
      });
    }
       var group = DateArray.reduce(function (r, o){
         var date = new Date(o); 
         var day =date.toString();
       (r[day]) ? r[day].count++ : r[day] = { count: 1 };
        return r; 
      }, {});
      
       var result = Object.keys(group).map((key) => group[key]);
       countArray = result.map(function(a) {return a.count;});
      this.NewLabelData = [...new Set(this.NewLabelData)];
      console.log( this.NewLabelData,countArray);
    this.GraphLabels = this.NewLabelData;
    this.pieChartOptions = {
      responsive: true,
      scales: { xAxes: [{},], yAxes: [{},], },
    };
    this.pieChartData = [
      { data: countArray, label: 'Patient Registration  Wise Analysis' },
    ];

    this.pieChartLabels = this.Labels;
    this.pieChartType = 'pie';
    this.pieChartLegend = true;
    this.isBarChart = false;

  }


  setLinegraphData() {
    this.isBarChart = true;
    let countArray = [];
    let DateArray = [];
    this.pieChartDataArray = [];
    this.NewLabelData = [];

    if (this.RegistrationArray?.length > 0) {
      this.RegistrationArray?.forEach(element => {
        DateArray.push(element.regDate)
       this.NewLabelData.push(this.datePipe.transform(element.regDate, "yyyy-MM-dd"))
      });
    }
       var group = DateArray.reduce(function (r, o){
         var date = new Date(o); 
         var day =date.toString();
       (r[day]) ? r[day].count++ : r[day] = { count: 1 };
        return r; 
      }, {});
      
       var result = Object.keys(group).map((key) => group[key]);
       countArray = result.map(function(a) {return a.count;});
      this.NewLabelData = [...new Set(this.NewLabelData)];
      console.log( this.NewLabelData,countArray);
    this.GraphLabels = this.NewLabelData;
    this.pieChartOptions = {
      responsive: true,
      scales: { xAxes: [{},], yAxes: [{},], },
    };
    this.pieChartData = [
      { data: countArray, label: 'Patient Registration  Wise Analysis' },
    ];

    this.lineChartLegend = true;
    this.lineChartPlugins = [];
    this.pieChartLabels = this.Labels;
    this.pieChartType = 'line';
    this.pieChartLegend = true;
    this.isBarChart = false;


  }
  setBargraphData() {
    this.isBarChart = true;
    let countArray = [];
    let DateArray = [];
    this.pieChartDataArray = [];
    this.NewLabelData = [];

    if (this.RegistrationArray?.length > 0) {
      this.RegistrationArray?.forEach(element => {
        DateArray.push(element.regDate)
       this.NewLabelData.push(this.datePipe.transform(element.regDate, "yyyy-MM-dd"))
      });
    }
       var group = DateArray.reduce(function (r, o){
         var date = new Date(o); 
         var day =date.toString();
       (r[day]) ? r[day].count++ : r[day] = { count: 1 };
        return r; 
      }, {});
      
       var result = Object.keys(group).map((key) => group[key]);
       countArray = result.map(function(a) {return a.count;});
      this.NewLabelData = [...new Set(this.NewLabelData)];
      console.log( this.NewLabelData,countArray);
    this.GraphLabels = this.NewLabelData;
    this.pieChartOptions = {
      responsive: true,
      scales: { xAxes: [{},], yAxes: [{},], },
    };
    this.pieChartData = [
      { data: countArray, label: 'Patient Registration  Wise Analysis' },
    ];

    this.barChartLegend = true;
    this.pieChartLabels = this.Labels;
    this.pieChartType = 'bar'
    this.pieChartLegend = true;
   }
   


  setDailyBargraphData() {
    this.isBarChart = true;
    // this.isGraph = true;

    this.startdate = this.authService.getServerDate;
    this.enddate = this.authService.getServerDate;

    setTimeout(() => {
      this.get_records_between_two_dates();
    }, 1000);

    setTimeout(() => {
      this.setBargraphData();
    }, 1500);

  }


  setWeeklyBargraphData() {
    var oneWeekAgo = this.authService.getServerDate;
    oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);

    this.isBarChart = true;
    // this.isGraph = true;

    this.startdate = oneWeekAgo;
    this.enddate = this.authService.getServerDate;

    setTimeout(() => {
      this.get_records_between_two_dates();
    }, 1000);

    setTimeout(() => {
      this.setBargraphData();
    }, 1500);

  }
  setMonthelyBargraphData() {
    var d = this.authService.getServerDate;
    d.setMonth(d.getMonth() - 1);


    this.isBarChart = true;
    // this.isGraph = true;

    this.startdate = d;
    this.enddate = this.authService.getServerDate;

    setTimeout(() => {
      this.get_records_between_two_dates();
    }, 1000);

    setTimeout(() => {
      this.setBargraphData();
    }, 1500);



  }
  setQuaterlyBargraphData() {

    var d = this.authService.getServerDate;
    d.setMonth(d.getMonth() - 3);
    console.log(d)


    this.isBarChart = true;
    // this.isGraph = true;

    this.startdate = d;
    this.enddate = this.authService.getServerDate;

    setTimeout(() => {
      this.get_records_between_two_dates();
    }, 1000);

    setTimeout(() => {
      this.setBargraphData();
    }, 1500);


  }

  togglemonthelyIf(data: any) {

  }




  exportexcel(): void {
    this.exportdata.open_loader_Dialogtwo();
    this.startdate = this.authService.getServerDate;
    let element = document.getElementById('content');
    this.exportdata.Newexportxcel(element, this.pageHeading);

  }


  public openPDF(): void {
    this.startdate = this.authService.getServerDate;
    this.exportdata.open_loader_Dialogtwo();
    let DATA = document.getElementById('content');
    this.exportdata.downloadAsPDF(DATA, this.pageHeading);

  }
  public printPDF(): void {
    this.exportdata.printpDFData(); 
}
  printComponent(cmpName) {
    this.startdate = this.authService.getServerDate;
    window.print();

  }
  cityFilter() {
    let groupdata = this.citylist.reduce((r, { cityName }) => {
      if (!r.some(o => o.cityName == cityName)) {
        r.push({ cityName, UserItem: this.citylist.filter(v => v.cityName == cityName) });
      }
      return r;
    }, []);

    for (var i = 0; i < groupdata.length; i++) {
      this.patientTotal = 0;
      this.patientTotal = groupdata[i].UserItem.length;;
      this.alltotalCount = this.alltotalCount + this.patientTotal;
      this.RegistrationArraycity.push({
        "cityName": groupdata[i].cityName,
        "totalamount": this.patientTotal,
        "Useritem": groupdata[i].UserItem,
      });
    }
  }
}


